<template>
  <div class="process-area ptb-100 bg-f9f9f9">
    <div class="container">
      <div class="section-title text-center">
        <span class="sub-title">Nosso Processo</span>
        <h2>Como transformamos suas ideias em realidade</h2>
        <p>Seguimos uma metodologia ágil e transparente, garantindo qualidade e resultados em cada etapa do projeto.</p>
      </div>

      <div class="process-timeline">
        <!-- Step 1 -->
        <div class="process-step" data-aos="fade-up">
          <div class="step-number">
            <span>01</span>
          </div>
          <div class="step-content">
            <div class="step-icon">
              <i class="ph-handshake"></i>
            </div>
            <h3>Descoberta & Planejamento</h3>
            <p>Entendemos profundamente suas necessidades, objetivos de negócio e desafios. Criamos um plano detalhado com escopo, prazos e tecnologias ideais para seu projeto.</p>
            <ul class="step-features">
              <li><i class="ph-check-circle"></i> Reunião de alinhamento</li>
              <li><i class="ph-check-circle"></i> Análise de requisitos</li>
              <li><i class="ph-check-circle"></i> Proposta técnica e comercial</li>
            </ul>
          </div>
        </div>

        <!-- Step 2 -->
        <div class="process-step" data-aos="fade-up" data-aos-delay="100">
          <div class="step-number">
            <span>02</span>
          </div>
          <div class="step-content">
            <div class="step-icon">
              <i class="ph-figma-logo"></i>
            </div>
            <h3>Design & Prototipação</h3>
            <p>Criamos wireframes e protótipos interativos para validar a experiência do usuário antes do desenvolvimento. Garantimos que cada detalhe esteja alinhado com sua visão.</p>
            <ul class="step-features">
              <li><i class="ph-check-circle"></i> UX/UI Design moderno</li>
              <li><i class="ph-check-circle"></i> Protótipos interativos</li>
              <li><i class="ph-check-circle"></i> Aprovação antes do código</li>
            </ul>
          </div>
        </div>

        <!-- Step 3 -->
        <div class="process-step" data-aos="fade-up" data-aos-delay="200">
          <div class="step-number">
            <span>03</span>
          </div>
          <div class="step-content">
            <div class="step-icon">
              <i class="ph-code"></i>
            </div>
            <h3>Desenvolvimento Ágil</h3>
            <p>Desenvolvemos em sprints curtos, entregando funcionalidades incrementais para feedback rápido. Você acompanha o progresso em tempo real através de demos semanais.</p>
            <ul class="step-features">
              <li><i class="ph-check-circle"></i> Sprints de 2 semanas</li>
              <li><i class="ph-check-circle"></i> Código limpo e documentado</li>
              <li><i class="ph-check-circle"></i> Demos e feedbacks constantes</li>
            </ul>
          </div>
        </div>

        <!-- Step 4 -->
        <div class="process-step" data-aos="fade-up" data-aos-delay="300">
          <div class="step-number">
            <span>04</span>
          </div>
          <div class="step-content">
            <div class="step-icon">
              <i class="ph-bug"></i>
            </div>
            <h3>Testes & Qualidade</h3>
            <p>Realizamos testes rigorosos de funcionalidade, performance e segurança. Garantimos que tudo funcione perfeitamente antes do lançamento.</p>
            <ul class="step-features">
              <li><i class="ph-check-circle"></i> Testes automatizados</li>
              <li><i class="ph-check-circle"></i> Testes de segurança</li>
              <li><i class="ph-check-circle"></i> Homologação com cliente</li>
            </ul>
          </div>
        </div>

        <!-- Step 5 -->
        <div class="process-step" data-aos="fade-up" data-aos-delay="400">
          <div class="step-number">
            <span>05</span>
          </div>
          <div class="step-content">
            <div class="step-icon">
              <i class="ph-rocket-launch"></i>
            </div>
            <h3>Deploy & Lançamento</h3>
            <p>Fazemos o deploy em produção com estratégias de zero downtime. Configuramos monitoramento, backups e toda a infraestrutura necessária.</p>
            <ul class="step-features">
              <li><i class="ph-check-circle"></i> Deploy profissional</li>
              <li><i class="ph-check-circle"></i> Infraestrutura otimizada</li>
              <li><i class="ph-check-circle"></i> Treinamento da equipe</li>
            </ul>
          </div>
        </div>

        <!-- Step 6 -->
        <div class="process-step" data-aos="fade-up" data-aos-delay="500">
          <div class="step-number">
            <span>06</span>
          </div>
          <div class="step-content">
            <div class="step-icon">
              <i class="ph-headset"></i>
            </div>
            <h3>Suporte & Evolução</h3>
            <p>Oferecemos suporte contínuo, manutenção preventiva e novas funcionalidades. Seu projeto evolui junto com seu negócio.</p>
            <ul class="step-features">
              <li><i class="ph-check-circle"></i> Suporte 24/7</li>
              <li><i class="ph-check-circle"></i> Manutenção preventiva</li>
              <li><i class="ph-check-circle"></i> Evolução contínua</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="cta-section text-center" data-aos="fade-up">
        <h3>Pronto para começar seu projeto?</h3>
        <p>Fale com nosso time e descubra como podemos ajudar seu negócio a crescer</p>
        <a href="https://wa.me/5554992302401?text=Quero saber mais sobre o processo de desenvolvimento"
           target="_blank"
           class="btn-style-one green-color"
           rel="noopener noreferrer">
          <i class="flaticon-whatsapp"></i>
          Iniciar Conversa no WhatsApp
          <i class="ph-caret-right"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Process'
}
</script>

<style scoped>
.process-timeline {
  position: relative;
  margin-top: 60px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.process-timeline::before {
  content: '';
  position: absolute;
  left: 40px;
  top: 60px;
  bottom: 60px;
  width: 2px;
  background: linear-gradient(180deg, #6D5DFC 0%, #4361EE 100%);
}

.process-step {
  position: relative;
  padding-left: 120px;
  margin-bottom: 60px;
}

.step-number {
  position: absolute;
  left: 0;
  top: 0;
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #6D5DFC 0%, #4361EE 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 30px rgba(109, 93, 252, 0.3);
  z-index: 2;
}

.step-number span {
  font-size: 28px;
  font-weight: 700;
  color: white;
}

.step-content {
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
}

.step-content:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.12);
}

.step-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, rgba(109, 93, 252, 0.1) 0%, rgba(67, 97, 238, 0.1) 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.step-icon i {
  font-size: 32px;
  color: #6D5DFC;
}

.step-content h3 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #1a1a1a;
}

.step-content p {
  color: #666;
  line-height: 1.8;
  margin-bottom: 20px;
}

.step-features {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 10px;
}

.step-features li {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #444;
  font-size: 15px;
}

.step-features i {
  color: #25D366;
  font-size: 20px;
}

.cta-section {
  margin-top: 80px;
  padding: 50px;
  background: linear-gradient(135deg, #6D5DFC 0%, #4361EE 100%);
  border-radius: 20px;
  color: white;
}

.cta-section h3 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 15px;
  color: white;
}

.cta-section p {
  font-size: 18px;
  margin-bottom: 30px;
  opacity: 0.9;
  color: white;
}

.btn-style-one.green-color {
  background: #25D366;
  border-color: #25D366;
}

.btn-style-one.green-color:hover {
  background: #128C7E;
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .process-timeline::before {
    left: 25px;
  }

  .process-step {
    padding-left: 80px;
  }

  .step-number {
    width: 50px;
    height: 50px;
  }

  .step-number span {
    font-size: 20px;
  }

  .step-content {
    padding: 20px;
  }

  .step-content h3 {
    font-size: 20px;
  }

  .cta-section {
    padding: 30px 20px;
  }

  .cta-section h3 {
    font-size: 24px;
  }
}
</style>